<template>
  <div class="detail-table" v-resize="onResize">
    <div class="action-bar" v-if="windowSize > 600">
      <v-checkbox
        @change="push_all()"
        v-model="checkbox_all"
        hide-details
      ></v-checkbox>
      <!-- value="red" -->
      <div class="subtitle">Action</div>
      <div style="border: 0" class="btn-filter">ส่งอีกครั้ง</div>
      <v-btn
        :disabled="this.select_order.length == 0 ? true : false"
        rounded
        @click="confirmAction"
        class="ok"
        >Submit</v-btn
      >
      <div class="count-subtitle">
        พบ {{ data.length }} รายการ (เลือกแล้ว
        {{ this.select_order.length }} รายการ)
      </div>
    </div>
    <div class="action-bar" v-else style="padding: 5px 0 5px 0">
      <div class="count-subtitle" style="">พบ {{ data.length }} รายการ</div>
    </div>
    <div class="table d-flex flex-wrap justify-center">
      <div v-if="loading_status" style="z-index: 1; position: absolute">
        <v-progress-circular
          :size="100"
          color="primary"
          indeterminate
        ></v-progress-circular>
      </div>

      <div
        id="test"
        :class="[
          row.disable != 1 &&
          find(row.purchase_id) &&
          row.order_status == 'Complete'
            ? 'card selected'
            : 'card',
          row.disable == 1 ? 'card disable' : ''
        ]"
        v-for="(row, index) in data"
        :key="'card-' + index + '-' + row.purchase_id"
      >
        <div class="row-card" style="padding-left: 10px">
          <div style="display: flex; width: 100%">
            <div style="padding-top: 0px; width: 7%">
              <div>
                <v-checkbox
                  @change="push(row)"
                  v-model="select_order"
                  :value="row.purchase_id"
                  hide-details
                ></v-checkbox>
              </div>
            </div>
            <div class="title-card" style="padding-top: 5px">
              หมายเลขคำสั่งซื้อ
            </div>
            <div class="value-card" style="padding-top: 5px">
              {{ row.purchase_id }}
            </div>
          </div>
        </div>

        <div class="row-card">
          <div style="width: 7%"></div>
          <div class="title-card">วันที่สั่งซื้อ</div>
          <div class="value-card">{{ formatDate(row.order_date) }}</div>
        </div>

        <div class="row-card">
          <div style="width: 7%"></div>
          <div class="title-card"></div>
          <div
            class="view-detail"
            @click="view(row)"
            style="margin-right: 10px"
          >
            ส่งอีกครั้ง
          </div>
        </div>
      </div>
      <div
        style="padding-top: 8%; font-size: 40px; color: rgba(0, 0, 0, 0.6)"
        class="table d-flex flex-wrap justify-center"
        v-if="data.length == 0"
      >
        ไม่พบข้อมูลที่ค้นหา กรุณากรอกข้อมูลใหม่
      </div>
    </div>

    <v-dialog persistent v-model="confirmDisable" max-width="454" width="454">
      <v-card>
        <div class="d-dialog">
          <div class="bg-confirm">
            <div style="text-align: center">
              <img class="img" src="@/assets/images/no.png" />
            </div>
            <div style="padding: 0px 10px">
              คุณต้องการ
              <span style="font-weight: bold">ลบหมายเลขคำสั่งซื้อ</span
              >ใช่หรือไม่
            </div>
          </div>
          <div class="bg-confirm-action">
            <div>
              <v-btn
                rounded
                @click="submit()"
                class="ok"
                style="margin-right: 45px"
                >ใช่</v-btn
              >
              <v-btn rounded @click="confirmDisable = false" class="clear"
                >ไม่</v-btn
              >
            </div>
          </div>
        </div>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogDetail"
      persistent
      max-width="600"
      max-height="300"
      class="d-dialog"
    >
      <v-card style="border-radius: 14px">
        <div v-resize="onResize" id="detail-dialog-admin">
          <div
            class="d-dialog"
            :style="{
              padding:
                windowSize < 600 ? '0px 5px 10px 0px' : '25px 25px 15px 25px'
            }"
          >
            <div style="width: 100%; display: flex">
              <div class="btn-filter-head">Resend Email</div>
            </div>
            <div class="box-detail">
              <b-container
                style="font-family: 'Bai Jamjuree', sans-serif"
                class="accentbv-example-row"
              >
                <b-row
                  style="
                    border-radius: 8px;
                    height: 54px;
                    background-color: #ecf1ff;
                  "
                >
                  <b-col style="height: 100%; padding: 0px" xl>
                    <div
                      style="
                        font-weight: 600;
                        font-size: 14px;
                        text-align: center;
                        display: flex;
                        align-items: center;
                        height: 100%;
                      "
                      class="md-layout"
                    >
                      <div style="width: 5%">#</div>
                      <div style="width: 23%">หมายเลขคำสั่งซื้อ</div>
                      <div style="width: 25%">
                        <div style="height: 50%">
                          ถึงฝ่ายบัญชี
                          <v-tooltip color="rgba(0, 0, 0, 0.8)" right>
                            <template v-slot:activator="{ on, attrs }">
                              <span
                                v-bind="attrs"
                                v-on="on"
                                class="mdi mdi-information"
                              ></span>
                            </template>
                            <span v-if="email_accounting.length == 0">
                              <div
                                style="
                                  font-family: 'Bai Jamjuree', sans-serif;
                                  font-weight: 500;
                                  font-size: 12px;
                                  text-align: center;
                                "
                              >
                                กรุณาตรวจสอบอีเมลผู้รับฝ่ายบัญชี
                              </div>
                            </span>
                            <span v-else>
                              <div
                                style="
                                  font-family: 'Bai Jamjuree', sans-serif;
                                  font-weight: 500;
                                  font-size: 12px;
                                  text-align: center;
                                "
                              >
                                อีเมลฝ่ายบัญชี
                              </div>
                              <div
                                style="font-size: 10px"
                                v-for="(row, index) in email_accounting"
                                :key="index + row.id + ' all'"
                              >
                                <span
                                  style="font-size: 5px"
                                  class="mdi mdi-record"
                                ></span>
                                {{ row.acc_email }}
                              </div>
                            </span>
                          </v-tooltip>
                        </div>
                        <div
                          style="
                            display: flex;
                            justify-content: center;
                            height: 50%;
                          "
                        >
                          <v-checkbox
                            @click="checkAllAccounting()"
                            :disabled="
                              email_accounting.length == 0 ? true : false
                            "
                            style="margin: 0"
                            v-model="send_accounting_"
                            hide-details
                          ></v-checkbox>
                        </div>
                      </div>
                      <div style="width: 10%">
                        <div style="front-s height: 50%;">ถึงลูกค้า</div>
                        <div
                          style="
                            display: flex;
                            justify-content: center;
                            height: 50%;
                          "
                        >
                          <!-- :disabled="disableCheckAll" -->
                          <v-checkbox
                            @click="checkAllCustomer()"
                            style="margin: 0"
                            v-model="send_customer_"
                            hide-details
                          ></v-checkbox>
                        </div>
                      </div>
                      <div style="width: 32%">อีเมลลูกค้า</div>
                    </div>
                  </b-col>
                </b-row>

                <b-row>
                  <b-col
                    style="overflow-y: scroll; max-height: 420px; padding: 0px"
                    xl
                  >
                    <div
                      v-for="(row, index) in temp_data"
                      :key="index + row.purchase_id"
                      :style="{
                        'margin-top': '10px',
                        background: '#ffffff',
                        border: '0.7px solid rgba(0, 0, 0, 0.2)',
                        'border-radius': '8px',
                        'font-weight': '600',
                        'font-size': '14px',
                        'text-align': 'center',
                        display: 'flex',
                        'align-items': 'center',
                        height: row.inp_mail == 0 ? '40px' : '50px'
                      }"
                      class="md-layout"
                    >
                      <div style="width: 5%">{{ index + 1 }}</div>
                      <div style="width: 23%">{{ row.purchase_id }}</div>
                      <div style="width: 25%">
                        <div
                          class="CB"
                          style="display: flex; justify-content: center"
                        >
                          <input
                            @change="checkBox('acc', row)"
                            v-model="row.acc_all"
                            :disabled="
                              email_accounting.length == 0 ? true : false
                            "
                            type="checkbox"
                          />
                        </div>
                      </div>
                      <!-- @change="checkBoxSendmail('cus' ,row , check_box_cus)" -->
                      <!-- :disabled="!row.change_address && row.cus_email != '' ? false : true" -->
                      <div class="CB" style="width: 10%">
                        <div style="display: flex; justify-content: center">
                          <input
                            @change="checkBox('cus', row)"
                            v-model="row.cus_all"
                            type="checkbox"
                          />
                        </div>
                      </div>
                      <div
                        class="in-email"
                        style="padding: 0 5px 0 0; width: 37%"
                      >
                        <!-- v-if="!row.change_address && row.cus_all != '' " -->
                        <div class="search">
                          <span class="form-element">
                            <!-- <span
                              @click="refesh_val(row, index)"
                              v-if="!row.change_address "
                              style="background-color: #fff; cursor: pointer"
                              class="mdi mdi-refresh mdi-18px"
                            ></span> -->
                            <input
                              @change="changeEmailCustomer($event)"
                              v-model="row.cus_email"
                              :placeholder="row.df_mail"
                            />
                          </span>
                        </div>
                        <!-- <input
                          v-if="row.change_address || row.cus_email == '' "
                          disabled="true"
                          style="
                            width: 100%;
                            height: 28px;
                            background: #d9d9d9;
                            border: 1px solid rgba(0, 0, 0, 0.12);
                            border-radius: 8px;
                          "
                          type="text"
                        /> -->
                      </div>
                      <!-- inp_mail = 0 ==> ปกติ -->
                      <!-- inp_mail = 1 ==> กรอกอีเมล -->
                      <!-- inp_mail = 2 ==> รูปแบบผิด -->
                      <div
                        style="display: flex; width: 100%"
                        v-if="row.inp_mail == 1"
                      >
                        <div style="width: 65%"></div>
                        <small class="txt-wrong">กรุณากรอกอีเมล</small>
                      </div>
                      <div
                        v-else-if="row.inp_mail == 2"
                        style="display: flex; width: 100%"
                      >
                        <div style="width: 65%"></div>
                        <small class="txt-wrong"
                          >กรุณากรอกอีเมลให้ถูกต้อง</small
                        >
                      </div>
                    </div>
                  </b-col>
                </b-row>
              </b-container>
            </div>

            <div class="box-footer">
              <span @click="closeDialogDetail()" style="cursor: pointer"
                >ยกเลิก</span
              >
              <v-btn
                rounded
                :disabled="
                  data_resend == '' || data_resend.length == 0 ? true : false
                "
                @click="submitDialogDetail('save')"
                class="ok"
                :style="{ 'margin-left': '20px' }"
                >ตกลง</v-btn
              >
            </div>
          </div>
        </div>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="confirmResend" max-width="454" width="454">
      <v-card>
        <div class="d-dialog">
          <div class="bg-confirm">
            <div
              v-if="loading_status_popup"
              style="z-index: 1000; position: absolute; width: 100%; top: 100px"
            >
              <v-progress-circular
                :size="100"
                color="primary"
                indeterminate
              ></v-progress-circular>
            </div>
            <div style="text-align: center">
              <img class="img" src="@/assets/images/mail_resend.png" />
            </div>
            <div
              style="font-family: 'Bai Jamjuree', sans-serif; padding: 0px 10px"
            >
              คุณต้องการ
              <span style="font-weight: bold">ส่งอีเมลอีกครั้ง</span>ใช่หรือไม่
            </div>
          </div>
          <div class="bg-confirm-action">
            <div>
              <v-btn
                :disabled="loading_status_popup"
                rounded
                @click="save()"
                class="ok"
                style="margin-right: 45px"
                >ใช่</v-btn
              >
              <v-btn
                rounded
                @click="closeConfirmResendDialog()"
                class="clear"
                :disabled="loading_status_popup"
                >ไม่</v-btn
              >
            </div>
          </div>
        </div>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialog_success"
      persistent
      max-width="350"
      id="dialogCinfrim"
    >
      <v-card style="border-radius: 14px">
        <v-card-title style="background-color: #ecf1ff" class="text-h5">
          <div style="width: 100%">
            <div style="text-align: center; margin-bottom: 20px">
              <img
                class="img"
                src="@/assets/images/success.png"
                style="height: 120px"
              />
            </div>
            <div
              style="
                font-family: 'Bai Jamjuree';
                text-align: center;
                font-size: 16px;
              "
            >
              ส่งอีเมลสำเร็จ
            </div>
          </div>
        </v-card-title>
        <div style="padding: 15px 0px; text-align: center">
          <v-btn
            rounded
            @click="closeSuccessDialog()"
            class="ok"
            :style="{ 'margin-left': '20px' }"
            >ตกลง</v-btn
          >
          <!-- @click="close_success" -->
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// import { runInThisContext } from 'vm'

export default {
  name: 'detail-table',
  props: {
    data: Array,
    dataShipping: Array,
    email_ac: Array,
    loading_status: Boolean
  },
  data () {
    return {
      dialogDetail: false,
      confirmResend: false,
      confirmDisable: false,
      select_order: [],
      windowSize: 1366,
      checked: true,
      checkbox_all: false,
      checkbox_true: true,
      count: 0,
      dataPage: this.data,
      deviceType: null,
      calcCardWidth: 20,
      monthsShort: [
        // 'JAN',
        // 'FEB',
        // 'MAR',
        // 'APR',
        // 'MAY',
        // 'JUN',
        // 'JUL',
        // 'AUG',
        // 'SEP',
        // 'OCT',
        // 'NOV',
        // 'DEC'
        'ม.ค.',
        'ก.พ.',
        'มี.ค.',
        'เม.ย.',
        'พ.ค.',
        'มิ.ย.',
        'ก.ค.',
        'ส.ค.',
        'ก.ย.',
        'ต.ค.',
        'พ.ย.',
        'ธ.ค.'
      ],
      actionOrder: 0,
      action_list: [
        {
          id: '1',
          txt: 'Disable'
        },
        {
          id: '2',
          txt: 'Resend'
        }
      ],
      send_accounting_: '',
      send_customer_: '',
      temp_data: [],
      check_box_cus: '',
      email_accounting: [],
      data_resend: '',
      dialog_success: false,
      confirmResend: false,
      loading_status_popup: false,
      disableCheckAll: false
    }
  },
  computed: {},
  watch: {
    select_order (newValue) {},
    data (newValue) {
      this.checkbox_all = false
    }
  },
  methods: {
    checkAllAccounting () {
      this.checkAll('acc')
    },
    checkAllCustomer () {
      this.checkAll('cus')
    },
    checkAll (mode) {
      const res = []

      for (let index = 0; index < this.temp_data.length; index++) {
        const element = this.temp_data[index]
        if (mode == 'acc') {
          element.acc_all = this.send_accounting_
          this.temp_data[index].checked_acc = element.acc_all
        } else {
          element.cus_all = this.send_customer_

          this.temp_data[index].checked_cus = element.cus_all
        }

        if (element.acc_all || element.cus_all) {
          if (element.acc_all && element.cus_all) {
            res.push({
              purchase_id: element.purchase_id,
              send_to: 'accounting/customer',
              cus_email: element.cus_email
            })
          } else {
            res.push({
              purchase_id: element.purchase_id,
              send_to: element.acc_all ? 'accounting' : 'customer',
              cus_email: element.acc_all ? '' : element.cus_email
            })
          }
        }
      }
      this.data_resend = res
    },
    closeSuccessDialog () {
      this.temp_data = []
      this.dialog_success = false
    },
    changeEmailCustomer (param) {
      // console.log(param)
    },
    refesh_val (param, indexTemp) {
      if (this.data_resend == '') {
        this.temp_data[indexTemp].cus_email = param.df_mail
        param.cus_email = param.df_mail
      } else {
        let index = this.data_resend.findIndex(
          x => x.purchase_id == param.purchase_id
        )
        this.data_resend[index].cus_email = param.df_mail
        param.cus_email = param.df_mail
      }
    },
    checkBoxSendmail () {},
    checkBox (mode, param) {
      if (mode == 'acc') {
        if (param.checked_acc) {
          param.checked_acc = false
        } else {
          param.checked_acc = true
        }
      } else {
        if (param.checked_cus) {
          param.checked_cus = false
        } else {
          param.checked_cus = true
        }
      }
      // console.log(this.temp_data)
      const res = []

      for (let index = 0; index < this.temp_data.length; index++) {
        const element = this.temp_data[index]

        if (element.checked_acc || element.checked_cus) {
          if (element.checked_acc && element.checked_cus) {
            res.push({
              purchase_id: element.purchase_id,
              send_to: 'accounting/customer',
              cus_email: element.cus_email
            })
          } else {
            res.push({
              purchase_id: element.purchase_id,
              send_to: element.checked_acc ? 'accounting' : 'customer',
              cus_email: element.checked_acc ? '' : element.cus_email
            })
          }
        }
      }

      let result_cus_all = this.temp_data.filter(x => x.cus_all == true)
      let result_acc_all = this.temp_data.filter(x => x.acc_all == true)

      if (result_acc_all.length > 0) {
        if (result_acc_all.length != this.temp_data.length) {
          this.send_accounting_ = false
        } else {
          this.send_accounting_ = true
        }
      }
      if (result_cus_all.length > 0) {
        if (result_cus_all.length != this.temp_data.length) {
          this.send_customer_ = false
        } else {
          this.send_customer_ = true
        }
      }

      this.data_resend = res
    },
    confirmAction () {
      let res1 = {
        id: '',
        event: 'getactive',
        acc_email: '',
        acc_name: '',
        is_active: ''
      }

      this.$store
        .dispatch('getAccountEmail', res1)
        .then(res => {
          // console.log(res)
          this.email_accounting = res
          // this.loading_status = false
        })
        .catch(error => {
          if (error.response.status == 401) {
            sessionStorage.removeItem('user_profile')
            sessionStorage.removeItem('token_seesion')
            this.tokenExpired = true
            console.log('Error 401')
          }
        })

      this.dialogDetail = true
      let ArrayTemp = []
      for (let index = 0; index < this.select_order.length; index++) {
        const P = this.select_order[index]
        const found = this.data.find(element => element.purchase_id == P)
        let result = this.cloneObj(found)
        let foundClone = this.cloneObj(found)
        result.df_mail = foundClone.cus_email
        result.cus_all = false
        result.acc_all = false
        result.inp_mail = false
        ArrayTemp.push(result)
      }
      console.log(ArrayTemp)
      // change_address
      let disALl = ArrayTemp.filter(
        x => x.change_address == 0 && x.cus_email != ''
      )
      console.log(disALl)
      if (disALl.length > 0) {
        this.disableCheckAll = false
      } else {
        this.disableCheckAll = true
      }
      this.temp_data = ArrayTemp
      this.data_resend = ''
      this.send_customer_ = false
      this.send_accounting_ = false
    },
    closeConfirmResendDialog () {
      if (this.loading_status_popup == false) {
        this.temp_data = []
        this.confirmDisable = false
        this.confirmResend = false
      }
    },
    closeDialogDetail () {
      this.temp_data = []
      this.$emit('close', {})
      this.$emit('fetch', {})
      this.dialogDetail = false
    },
    push (param) {
      // console.log(param)
      // console.log(this.select_order)
    },
    formatDate (val) {
      if (val !== null) {
        let hours = ''
        let min = ''
        let today = new Date(val)
        // const year = today.getFullYear()
        // const fullYear = year
        const year = today.getFullYear()
        const fullYear = year
        // const fullYear = year + 543
        const days = today.getDate()
        const h = today.getHours()
        const m = today.getMinutes()
        const monthName = this.monthsShort[today.getMonth()]

        return days + ' ' + monthName + ' ' + fullYear
      } else {
        return val
      }
    },
    OnAction () {
      this.checkbox_all = false
      let result = this.data.filter(
        x =>
          x.order_status == 'Complete' &&
          x.disable == 0 &&
          this.actionOrder == 'Disable'
      )
      let select_order = JSON.parse(JSON.stringify(this.select_order))
      this.select_order = select_order.filter(function (n) {
        return result.indexOf(n) !== -1
      })
    },
    push_all () {
      let result = ''
      result = this.data
      let select_order = JSON.parse(JSON.stringify(this.select_order))
      let purchase = result.map(e => e.purchase_id)
      if (this.checkbox_all) {
        this.select_order = purchase
      } else {
        this.select_order = select_order.filter(function (n) {
          return result.indexOf(n) !== -1
        })
      }
    },
    submitDialogDetail () {
      let checkValid = []
      let tempData = this.cloneObj(this.temp_data)
      for (let index = 0; index < this.data_resend.length; index++) {
        const element = this.data_resend[index]
        let key = tempData.findIndex(x => x.purchase_id == element.purchase_id)
        let temp = tempData[key]
        if (
          element.send_to == 'customer' ||
          element.send_to == 'accounting/customer'
        ) {
          if (temp.cus_email == '') {
            tempData[key].inp_mail = 1
            checkValid.push(element)
          } else if (!this.syntaxEmail_(temp.cus_email)) {
            tempData[key].inp_mail = 2
            checkValid.push(element)
          } else {
            tempData[key].inp_mail = 0
          }
        }
        this.data_resend[index].cus_email = temp.cus_email
      }
      this.temp_data = tempData
      if (checkValid.length > 0) {
      } else {
        this.confirmResend = true
        this.dialogDetail = false
      }
    },
    save () {
      if (this.loading_status_popup == false) {
        this.loading_status_popup = true
        let theArray = []
        theArray.push(this.data_resend)

        for (let index = 0; index < this.data_resend.length; index++) {
          const element = this.data_resend[index]
          let result = this.temp_data.filter(
            x => x.purchase_id == element.purchase_id
          )
          this.data_resend[index].cus_email = result[0].cus_email
        }
        this.$store
          .dispatch('resendMail', this.data_resend)
          .then(res => {
            this.loading_status_popup = false
            this.confirmResend = false
            this.dialog_success = true
          })
          .catch(error => {
            this.loading_status_popup = false
            if (error.response.status == 401) {
              sessionStorage.removeItem('user_profile')
              sessionStorage.removeItem('token_seesion')
              this.tokenExpired = true
              console.log('Error 401')
            }
          })
      }
    },
    find (param) {
      const found = this.select_order.find(element => element == param)
      if (!found) {
        return false
      } else {
        return true
      }
    },
    select_ (param) {
      const found = this.select_order.find(element => element == param)
      if (!found) {
        return false
      } else {
        return true
      }
    },
    view (row) {
      let theArray = []
      // console.log(row)
      this.$emit('view', row)
    },
    print (row) {
      this.$emit('print', row)
    },
    onResize () {
      let x = window.innerWidth
      let y = window.innerHeight
      this.windowSize = x
      this.deviceType = window.deviceType()
    },
    cloneObj (newValue) {
      return JSON.parse(JSON.stringify(newValue))
    },
    syntaxEmail_ (email) {
      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
        return true
      } else {
        return false
      }
    }
  }
}
</script>
<style></style>
